import { render } from "./ChangePassword.vue?vue&type=template&id=cf23a5de&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&lang=ts"
export * from "./ChangePassword.vue?vue&type=script&lang=ts"

import "./ChangePassword.vue?vue&type=style&index=0&id=cf23a5de&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-cf23a5de"

export default script